import type { GameState } from '../state/gameState';
import { itemIconKey, TX } from '../registry/keys';

/** Badges derived purely from the current GameState — no extra persistence. */
export interface Achievement {
  id: string;
  name: string;
  desc: string;
  icon: string;
  done: (s: GameState) => boolean;
}

const fishCaught = (s: GameState): number =>
  (s.collected['fish'] ?? 0) + (s.collected['fish_bass'] ?? 0) + (s.collected['fish_trout'] ?? 0);

export const ACHIEVEMENTS: Achievement[] = [
  { id: 'first_sprout', name: 'First Sprout', desc: 'Harvest your first crop', icon: itemIconKey('turnip'), done: (s) => s.stats.cropsHarvested >= 1 },
  { id: 'green_thumb', name: 'Green Thumb', desc: 'Harvest 50 crops', icon: itemIconKey('strawberry'), done: (s) => s.stats.cropsHarvested >= 50 },
  { id: 'master_farmer', name: 'Master Farmer', desc: 'Harvest 250 crops', icon: itemIconKey('pumpkin'), done: (s) => s.stats.cropsHarvested >= 250 },
  { id: 'pocket_money', name: 'Pocket Money', desc: 'Earn 500g in all', icon: TX.coin, done: (s) => s.stats.totalEarned >= 500 },
  { id: 'tycoon', name: 'Tycoon', desc: 'Earn 10,000g in all', icon: TX.coin, done: (s) => s.stats.totalEarned >= 10000 },
  { id: 'rancher', name: 'Rancher', desc: 'Keep three animals', icon: TX.cow, done: (s) => s.animals.length >= 3 },
  { id: 'angler', name: 'Angler', desc: 'Catch a fish', icon: itemIconKey('fish'), done: (s) => fishCaught(s) > 0 },
  { id: 'jeweler', name: 'Jeweler', desc: 'Mine a sparkling gem', icon: itemIconKey('gem'), done: (s) => (s.collected['gem'] ?? 0) > 0 },
  { id: 'best_friends', name: 'Best Friends', desc: 'Reach 15 hearts with Clara', icon: TX.heart, done: (s) => s.claraHearts >= 15 },
  { id: 'pet_pal', name: 'Pet Pal', desc: 'Pet your pet 20 times', icon: TX.pet, done: (s) => s.petHearts >= 20 },
  { id: 'decorator', name: 'Decorator', desc: 'Place 10 decorations', icon: itemIconKey('flowerpot'), done: (s) => s.decorations.length >= 10 },
  { id: 'homemaker', name: 'Homemaker', desc: 'Play for 10 days', icon: TX.house, done: (s) => s.stats.daysPlayed >= 10 },
  { id: 'completionist', name: 'Completionist', desc: 'Complete the collection', icon: TX.heart, done: (s) => !!s.flags['collection_done'] },
];

export const achievementsDone = (s: GameState): number => ACHIEVEMENTS.filter((a) => a.done(s)).length;
